import { Router } from '@angular/router';
import { MatDialogRef, MatSort, MatPaginator } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { DataTableSource } from '../../../classes/DataTableSource/datatablesource';
import { FormStatusPipe } from '../../../pipes/formstatus.pipe';
var ClassicNotificationDialogComponent = /** @class */ (function () {
    function ClassicNotificationDialogComponent(dialogRef, data, mediaChange, formStatusPipe, router) {
        this.dialogRef = dialogRef;
        this.mediaChange = mediaChange;
        this.formStatusPipe = formStatusPipe;
        this.router = router;
        this._subrelease = new Subject();
        this.IsAdvisor = false;
        this.TitleText = data.TitleText || 'Notification Details...';
        this.MessageText = data.MessageText || '';
        this.Details = data.Details || [];
        this.IsAdvisor = data.IsAdvisor || false;
    }
    ClassicNotificationDialogComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    ClassicNotificationDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        var self = this;
        self.LastSizeCode = self.mediaChange.isActive('xs')
            ? 'xs'
            : self.mediaChange.isActive('sm')
                ? 'sm'
                : self.mediaChange.isActive('md')
                    ? 'md'
                    : self.mediaChange.isActive('lg')
                        ? 'lg'
                        : 'xl';
        self.SmallDisplay = self.LastSizeCode === 'xs' || self.LastSizeCode === 'sm';
        self.VisibleHeaders = self.SmallDisplay
            ? ['SmallDisplay']
            : this.IsAdvisor
                ? ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'SchoolName', 'FormStatus', 'DateUpdated', 'Actions']
                : ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'DateUpdated', 'Actions'];
        self.VisibleColumns = self.VisibleHeaders.slice();
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.LastSizeCode = media.mqAlias;
            self.VisibleHeaders = self.SmallDisplay
                ? ['SmallDisplay']
                : _this.IsAdvisor
                    ? ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'SchoolName', 'FormStatus', 'DateUpdated', 'Actions']
                    : ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'DateUpdated', 'Actions'];
            self.VisibleColumns = self.VisibleHeaders.slice();
        });
        this.DetailsData = new DataTableSource(this.Details, self.paginator, self.sorter, self.SortNotifications.bind(this));
    };
    // #region Go To Route Method
    // GoToRoute(detail: NotificationEntry) {
    //     //if (!detail || !detail.NavigationRoute || !detail.NavigationRoute.length) return;
    //     // Close the dialog
    //     this.dialogRef.close();
    //     // Route to the provided route
    //     //this.router.navigate(detail.NavigationRoute);
    // }
    // #endregion
    // #region OK Handler
    ClassicNotificationDialogComponent.prototype.OKHandler = function () {
        this.dialogRef.close(null);
    };
    // #endregion
    // #region Sort Notifications Method
    ClassicNotificationDialogComponent.prototype.SortNotifications = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'StudentName':
                _a = [First.StudentName, Second.StudentName], PropA = _a[0], PropB = _a[1];
                break;
            case 'StudentID':
                _b = [First.StudentID, Second.StudentID], PropA = _b[0], PropB = _b[1];
                break;
            case 'SchoolName':
                _c = [First.SchoolName || "", Second.SchoolName || ""], PropA = _c[0], PropB = _c[1];
                break;
            case 'FormStatus':
                _d = [First.FormStatus, Second.FormStatus], PropA = _d[0], PropB = _d[1];
                break;
        }
        var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
        var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
        return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        var _a, _b, _c, _d;
    };
    // #endregion
    // #region View College Method
    ClassicNotificationDialogComponent.prototype.ViewCollege = function (college) {
        var result = {
            DualEnrollStudentID: college.DualEnrollStudentID,
            StudentName: college.StudentName,
            StudentID: college.StudentID,
            CollegeID: college.CollegeID,
            Term: college.Term,
        };
        this.dialogRef.close(result);
    };
    return ClassicNotificationDialogComponent;
}());
export { ClassicNotificationDialogComponent };
// #region Custom Classes
// #region Classic Notification Dialog Options Class
var BaseClassicNotificationDialogOptions = /** @class */ (function () {
    function BaseClassicNotificationDialogOptions() {
    }
    return BaseClassicNotificationDialogOptions;
}());
export { BaseClassicNotificationDialogOptions };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/classicnotification/classicnotification.dialogcomponent.ts.pre-build-optimizer.js